import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "OpenAPI 사양",
  "description": "자체 호스팅 Remote Cache 서버를 위한 OpenAPI 사양입니다."
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "이 페이지는 사이드바 상단에 이 제목을 표시하기 위한 스텁입니다."
  }, {
    "heading": "",
    "content": "생성된 라우트는 next.config.ts에서 리디렉션됩니다."
  }],
  "headings": []
};
export const toc = [];
function _createMdxContent(props) {
  const _components = {
    p: "p",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.p, {
      children: "이 페이지는 사이드바 상단에 이 제목을 표시하기 위한 스텁입니다."
    }), "\n", _jsx(_components.p, {
      children: "생성된 라우트는 next.config.ts에서 리디렉션됩니다."
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
